import {BackendContentEditor} from 'components/Backend/ContentEditor';

export const title = '首頁內容編輯';

export default BackendContentEditor;
